import { Component } from 'react';
import {connect} from 'react-redux';
import {actions, Control, Errors, Form} from 'forms/rrf';
import {Button, Col, Container, Row} from 'react-bootstrap';
import PageTitle from '../../common/page-title';
import {getQuestions, verifyQuestions} from '../../../actions/login';
import LockPopup from '../lock-popup';
import TextViewer from '../../common/editor/text-viewer';
import './style.css';
import {USER_TYPE_REP, USER_TYPE_RETAILER, USER_TYPE_ADMIN} from '../../../data/userTypes';
import IgniteUkLogo from '../../../assets/img/ignite_logo_black.png';

class SeqQuestionsForm extends Component {
  state = {
    show: false
  };
  handleSubmit = (payLoad) => {
    const {dispatch, area} = this.props;

    const redirectUrl = {
      [USER_TYPE_RETAILER]: '/new-password',
      [USER_TYPE_ADMIN]: '/admin/new-password',
      [USER_TYPE_REP]: '/team/new-password',
    };
    dispatch(actions.submit('deep.resetPW.step3', verifyQuestions(payLoad, redirectUrl[area])
      .catch((error) => {
        dispatch({
          type: 'VERIFY_ANSWERS_REJECTED',
          payLoad: error.response.data
        });

        const {errors} = error.response.data;
        const rejectErrors = [];

        if (Object.prototype.toString.call(errors.security_answers) === '[object Array]') {
          errors.security_answers.forEach((curr) => {
            if (curr === 'INVALID_SECURITY_ANSWERS') {
              rejectErrors.push({invalid_answers: true});
            }
            if (curr === 'INVALID_CREDENTIALS') {
              rejectErrors.push({invalid_creds: true});
            }
            if (curr === 'INVALID_STATE') {
              rejectErrors.push({invalid_state: true});
            }
            if (curr === 'ACCOUNT_LOCKED') {
              rejectErrors.push({answers_exceeded: true});
              this.setState({show: true});
            }
          });
          return Promise.reject(rejectErrors);
        }
        return Promise.reject(errors);
      })));
  };

  UNSAFE_componentWillMount() {
    const {dispatch} = this.props;
    dispatch(actions.reset('deep.resetPW.step3'));
  }

  componentDidMount() {
    this.props.dispatch(getQuestions());
  }

  render() {
    return (
      <Container fluid className="security-questions user-inner-container">
        <Col lg={12}>
          <Row>
            <img src={IgniteUkLogo} alt="Ignite UK" />
            <PageTitle>
              Security questions
            </PageTitle>
          </Row>
          <TextViewer pageSlug='enter-security-questions'/>
          <Row>
            To ensure you are the account holder, please answer the security questions you have previously set below.
          </Row>
          <Row>
            <Form
              className="questions-form"
              model="deep.resetPW.step3"
              onSubmit={values => this.handleSubmit(values)}
            >

              <label htmlFor=".question1">
                {this.props.questions.questions.question1}
              </label>
              <Control.text
                className="form-control"
                model=".answer1"
                type="text"
                validateOn="change"
                validators={{required: val => val !== ''}}
              />
              <Errors
                className="errors"
                messages={{
                  required: () => 'This field is required'
                }}
                model=".answer1"
                show={{
                  touched: true,
                  focus: false
                }}
              />

              <label htmlFor=".question2">
                {this.props.questions.questions.question2}
              </label>
              <Control.text
                className="form-control"
                model=".answer2"
                type="text"
                validateOn="change"
                validators={{required: val => val !== ''}}
              />
              <Errors
                className="errors"
                messages={{
                  required: () => 'This field is required'
                }}
                model=".answer2"
                show={{
                  touched: true,
                  focus: false
                }}
              />

              <Errors
                className="errors"
                messages={{
                  invalid_answers: 'Invalid security answers given',
                  invalid_state: 'Invalid state',
                  invalid_creds: 'Invalid Credentials',
                  answers_exceeded: 'Security answer attempts exceeded'
                }}
                model="deep.resetPW.step3"
              />

              <br/>
              <Button
                className="red-btn float-end"
                disabled={!this.props.formValid}
                type="submit"
              >
                Submit
              </Button>

            </Form>
          </Row>
        </Col>
        {this.state.show && <LockPopup route="/login"/>}
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  questions: state.questions,
  formValid: state.deep.forms.resetPW.step3.$form.valid
});

export default connect(mapStateToProps)(SeqQuestionsForm);
